import useSnapshotFunctions from 'components/Dashboard/DashboardComponent/useSnapshotFunctions';
import { useEffect, useRef, useState } from 'react';
import createNotification from 'components/Settings/Utilities/CreateNotification';
import { useLoadKeywordLists } from 'components/Dashboard/utilities/loadKeyWords';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

const DashboardListComponent = (props) => {
  const { path, disabledCondition, setLocalKeywordsLists } = props ?? {};

  const [updatingItems, setUpdatingItems] = useState(new Set());
  const { updateIncludedForBriefings } = useSnapshotFunctions();

  const [keywordsLists, setKeywordsLists] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { loadKeywordsLists, compileKeywordsLists } = useLoadKeywordLists();
  const keywordsListsToUse = keywordsLists;

  const initialCall = useRef();
  initialCall.current = async (source) => {
    try {
      //AE: This call is necessary to includeHidden on keywordLists
      const lists = await loadKeywordsLists({ source, includehidden: true });
      if (!!lists) {
        const finalLists = compileKeywordsLists({ keywordsLists: lists });
        setKeywordsLists(finalLists);
        if (setLocalKeywordsLists) {
          setLocalKeywordsLists(finalLists);
        }
        setIsLoading(false);
      }
    } catch (error) {}
  };

  useEffect(() => {
    const source = new AbortController();
    initialCall.current(source);
    return () => {
      source.abort('Keywordslists for refine future briefings cancelled by the user');
    };
  }, []);

  const onChange = async (newValue, item) => {
    const originalValue = item.includedForBriefings;
    const newLists = keywordsLists.map((listItem) =>
      listItem.id === item.id ? { ...listItem, includedForBriefings: newValue } : listItem
    );
    setKeywordsLists(newLists);
    if (setLocalKeywordsLists) {
      setLocalKeywordsLists(newLists);
    }
    setUpdatingItems((prev) => new Set([...prev, item.id]));

    try {
      await updateIncludedForBriefings({
        keywordListId: item.id,
        includeInBriefings: newValue,
      });
      if (path === 'refine') {
        createNotification('success', 'Topics updated successfully');
      }
    } catch (error) {
      const newLists = keywordsLists.map((listItem) =>
        listItem.id === item.id ? { ...listItem, includedForBriefings: originalValue } : listItem
      );
      setKeywordsLists(newLists);

      if (setLocalKeywordsLists) {
        newLists;
      }
      if (path === 'refine') {
        createNotification('error', 'Failed to update topics');
      }
    } finally {
      setUpdatingItems((prev) => {
        const newSet = new Set(prev);
        newSet.delete(item.id);
        return newSet;
      });
    }
  };

  return (
    <>
      {isLoading ? (
        <div className='py-2'>
          <SkeletonTheme baseColor='#f2f2f2'>
            <Skeleton count={6} height={19} width={`100%`} />
          </SkeletonTheme>
        </div>
      ) : (
        <>
          {keywordsListsToUse.map((item) => (
            <ItemCheckbox
              item={item}
              onChange={onChange}
              disabled={updatingItems.has(item.id) || disabledCondition}
              key={`${path}-topic-list-item-${item.id}`}
              path={path}
            />
          ))}
        </>
      )}
    </>
  );
};

const ItemCheckbox = ({ item, onChange, disabled, path }) => {
  const checked = item?.includedForBriefings;
  return (
    <div
      className={`mb-0 ${
        path === 'refine' ? 'specific-x-padding-9 specific-y-padding-12' : 'specific-x-padding-16 specific-y-padding-9'
      }  pointer position-relative list-action-button ${disabled ? 'opacity-5 cursor-default' : ''}`}
    >
      <div className={`checkbox-item checkbox-item-empty d-flex my-0`}>
        <input
          type={'checkbox'}
          onChange={(e) => onChange(!checked, item)}
          name={`${path}-hideTopic-${item?.id}`}
          id={`${path}-hideTopic-${item?.id}-id`}
          checked={checked}
          disabled={disabled}
        />
        <label className='mb-0 flex-grow-1' htmlFor={`${path}-hideTopic-${item?.id}-id`}>
          <span className='hidden-lines hidden-one-line line-height-1-2' style={{ marginTop: '-1px' }}>
            {item?.name}
          </span>
        </label>
      </div>
    </div>
  );
};

export default DashboardListComponent;
